import React, { useContext, useState } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { addServiceSlice, addSaterialState } from './AddModalSlice'

import { servicesSlice } from '../ServicesSlice'

import Modal from '../../../components/Modal/Modal'
import { InputField, SelectField, NumberField } from '../../../components/FormElements/FormElements'
import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader'

import { Col, Row } from 'react-grid-system'
import { useNotification } from '../../../services/usenotification'

import SettingContext from '../../../services/context/setting-contentxt/setting-context'

import { useAPI } from '../../../services/hoc/useAPI'

const AddServiceModal= ({close}:{close:Function}) => {

    // Translation
    const t = useTranslation()
    const {alert,alertError500}=useNotification()
    const {isMobile} = useContext(SettingContext)
    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { add_service: addSaterialState }) => state.add_service)
  const ENDPOINTS = useAPI()

    // Hooks
    const [showErrors, setShowErrors] = useState<boolean>(false)

    const types_options = [
        { value: "Length", label: t("length") },
        { value: "Area", label: t("area") },
        { value: "Piece", label: t("piece") }
    ]

    // Add service
    const add = (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault()

        if (state.fields.name === "" || state.fields.serial_number === ""
        || !Boolean(state.fields.min_area)|| !Boolean(state.fields.unit)) {
            setShowErrors(true)
            return
        }

        dispatch(addServiceSlice.actions.setIsLoading(true))

        const endpoint = state.editId ? ENDPOINTS.glassWorks().update : ENDPOINTS.glassWorks().store

        endpoint({ id: state.editId, 
            name: state.fields.name || "", 
            code: state.fields.code || "", 
            min_area: state.fields.min_area, 
            unit: state.fields.unit, prices: [] })
            .then((response: any) => {
                dispatch(addServiceSlice.actions.setIsSuccess(true))
                setTimeout(() => {
                    toggle()
                    if (state.editId) {
                        dispatch(servicesSlice.actions.updateService(
                            { id: response.data.data.id, 
                                name: response.data.data.name,
                                 description: response.data.data.description, 
                                 serial_no: response.data.data.code, 
                                 min_area: response.data.data.min_area,
                                  unit: response.data.data.unit 
                                  ,code:response.data.data.code
                                }))
                    }

                    else {
                    dispatch(servicesSlice.actions.addServices([
                        { id: response.data.data.id, 
                            name: response.data.data.name,
                             description: response.data.data.description, 
                             serial_no: response.data.data.code, 
                             min_area: response.data.data.min_area,
                              unit: response.data.data.unit 
                              ,code:response.data.data.code
                            }]))
                        }
                }, 1000);
            })
            .catch((error:any)=>{
                dispatch(addServiceSlice.actions.setIsLoading(false))
                alertError500(error)
            })

    }

    const toggle = () => {
        dispatch(addServiceSlice.actions.setIsOpen(!state.isOpen))
        dispatch(addServiceSlice.actions.init())
        close()
    }

    return (
        <Modal open={state.isOpen} toggle={toggle}>

            {state.isLoading ? <WhiteboxLoader /> : ""}

            {state.isSuccess ? <SuccessMark /> : ""}

            <h2 className="text-center" style={{ margin: "0 0 20px" }}>{t("add_to_services")}</h2>

            <form onSubmit={add} style={{ width:isMobile?"280px" : 400, maxWidth: "100%" }}>

                <InputField
                    label={t("service_name") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addServiceSlice.actions.set({ name: e.target.value }))}
                    value={state.fields.name}
                    error={(showErrors && state.fields.name === "") ? t("required_error") : ""}
                />

                {/* <Textarea
                    label={t("service_description")}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addServiceSlice.actions.set({ description: e.target.value }))}
                    value={state.fields.description}
                    rows={4}
                    error={(showErrors && state.fields.description === "") ? t("required_error") : ""}
                /> */}

                <InputField
                    label={t("serial_number") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addServiceSlice.actions.set({ code: e.target.value }))}
                    value={state.fields.code}
                    error={(showErrors && state.fields.serial_number === "") ? t("required_error") : ""}
                />

                <Row>
                    <Col md={6}>

                        <NumberField
                            label={t("min") + " *"}
                            placeholder={t("min")}
                            min={0}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addServiceSlice.actions.set({ min_area: e.target.value }))}
                            value={state.fields.min_area}
                            error={(showErrors && !Boolean(state.fields.min_area)) ? t("required_error") : ""}
                            />
                    </Col>
                    <Col md={6}>
                        <SelectField
                    
                        error={(showErrors && !Boolean(state.fields.unit)) ? t("required_error") : ""}
                      
                            options={types_options}
                            value={types_options.find(option => option.value === state.fields.unit)}
                            onChange={(option: { value: string }) => dispatch(addServiceSlice.actions.set({ unit: option.value }))}

                        />
                    </Col>
                   
                </Row>
                

                {/* <button className="modal-secondary-botton" onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault()
                    dispatch(manageAttributesSlice.actions.setIsOpen(true))
                    if (state.fields.attributes?.length !== 0)
                        dispatch(manageAttributesSlice.actions.set(state.fields.attributes || []))
                }}>{t("manage_attributes")}</button> */}

                <button className="button round bg-gold color-white margin-top-30"
                 style={{ padding: isMobile? "0 40px" :"0 80px", marginBottom: 5 }}>{t("submit")}</button>

            </form>

            {/* <ManageAttributes set={(attributes: attribute[]) => dispatch(addServiceSlice.actions.set({ attributes }))} /> */}

        </Modal>
    )

}
export default AddServiceModal;